export default "__VITE_ASSET__BAPMTixQ__"